import React from "react"

import iconArrowUp from "../../assets/images/iconArrowUp.svg"
import iconArrowDown from "../../assets/images/iconArrowDown.svg"

export const TableBody = ({ rows, colSize }) => {
  return (
    <tbody>
      {rows?.map((row, idx) => (
        <TableRow key={idx} row={row} colSize={colSize} />
      ))}
    </tbody>
  )
}

export const TableRow = ({ row, colSize }) => {
  let firstCol = row.slice(0, 1)
  let bodyCols = row.slice(1)

  return (
    <tr
      className={`flex
		pb-[12px]
		table-row
	   
		border-0
		border-b-0.5
		border-slate-300
		md:h-16
		flex-wrap
		justify-between
		w-100`}
    >
      <TableHeaderCell content={firstCol} />
      {bodyCols.map((col, idx) => (
        <TableDataCell
          col={col}
          index={idx}
          key={idx}
          colSize={colSize}
          colouredBySign={idx === colSize - 2}
        />
      ))}
    </tr>
  )
}

export const TableDataCell = ({ col, index, colSize, colouredBySign }) => {
  let content = col
  let signColouredParentClassname = ""
  if (colouredBySign) {
    const sign = content.substring(0, 1)
    const className =
      sign === "+"
        ? `text-[#286350]`
        : sign === "-"
        ? `text-[#B50032]`
        : "text-[#000]"
    const iconClass = `pt-1 md:pt-0`
    const iconImage = sign === "+" ? iconArrowUp : iconArrowDown
    const icon =
      sign === "+" || sign === "-" ? (
        <img src={iconImage} alt="Info Icon" className={iconClass} />
      ) : (
        <img src={iconArrowUp} alt="Info Icon" className={iconClass} />
      )

    signColouredParentClassname = `table-cell`

    content = (
      <div className="flex flex-row justify-end items-baseline">
        <span className={className}>{content}</span>
        {icon}
      </div>
    )
  }

  return (
    <td
      className={`
			${colSize ? colSize[index] : "flex-1"}
			text-right
			font-inter
			text-[14px]
			leading-[130%]
			mr-[12px]
			md:text-right
			desk:text-[20px]
			${signColouredParentClassname}
		`}
    >
      {content}
    </td>
  )
}

export const TableHeaderCell = ({ content }) => {
  return (
    <th
      scope="row"
      className={`
		  
		  text-left
		  font-medium
		  font-inter
		  text-[14px]
		  leading-[130%]
		  pb-[6px]
		  pt-[12px]
  
		  md:w-auto
		  
	   
		  md:p-0
		  desk:whitespace-nowrap
		  desk:text-[20px]`}
    >
      {content}
    </th>
  )
}
